<template>
    <AppMainDialogForm v-model="dialog" :isLoading="isLoading" size='650' :tituloTela="tituloTela" :tooltip="tooltip" 
        :canDelete="rec.idInformeSaldoRacao != undefined" @initComponent="initComponent" @saveRegistro="saveRegistro" 
        @cancel="cancel" @deleteRegistro="beforeDeleteRationBalance" >
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs6 md6>
                    <SelectDate :rules="[campoSelectObrigatorio, validarData, validarDataFutura]" label="Data" v-model="registro.dtEntrada"></SelectDate>
                </v-flex>
                <v-flex class="item" xs5 md5>
                    <v-text-field :rules="[campoObrigatorio, campoMaiorOuIgualZero]" type="tel" v-model.number="registro.qtSaldo" 
                        label="Quantidade" outlined clearable v-mask="maskQuantidade"> </v-text-field>
                </v-flex>
            </v-layout>
        </v-form>
    </AppMainDialogForm>
</template>

<script>
    import { campoObrigatorio, campoSelectObrigatorio, validarData, isAValidFloat, campoMaiorZero, validarDataFutura, campoMaiorOuIgualZero } from '@/filters/rules'

    import AppMainDialogForm from '@/components/layout/AppMainDialogForm.vue'

    import SelectDate from '@/components/general/SelectDate.vue'
    import { dateLocalToIso, dateIsoToLocal } from '@/filters/utils'
    import { mask } from 'vue-the-mask'

    export default {
        components: {
            AppMainDialogForm,
            SelectDate,
        },
        directives: {
            mask,
        },
        data () {
            return {
                tooltip: 'Informar Saldo de Ração',
                tituloTela: 'Informar Saldo de Ração',
                isFormValid: false,
                isLoading: false,
                registro: {},
                dtEntrada: '',
                qtSaldo: '',
                isInserting: true,
                maskQuantidade: '#########',
            }
        },
        methods: {
            campoObrigatorio,
            campoSelectObrigatorio,
            dateLocalToIso,
            dateIsoToLocal,
            validarData,
            isAValidFloat,
            campoMaiorZero,
            validarDataFutura,
            campoMaiorOuIgualZero,
            initComponent() {          
                if (this.rec.idInformeSaldoRacao != undefined)
                {
                    this.registro.dtEntrada = this.dateIsoToLocal(this.rec.data)
                    this.registro.qtSaldo = this.rec.saldoInformado
                }
                else
                {
                    this.registro = {}
                    if (this.$refs.form != undefined)
                    {
                        this.$refs.form.reset()
                    }
                }
                this.$emit('openDialog')
            },
            saveRegistro() {
                if (this.$refs.form.validate())
                {
                    var floatQtSaldo = this.registro.qtSaldo
                    var rec = {
                        cdLoteProducao: this.$route.params.id,
                        dtEntrada: this.dateLocalToIso(this.registro.dtEntrada),
                        qtSaldo: parseFloat(parseFloat(floatQtSaldo).toFixed(3))
                    }
                    if (this.rec.idInformeSaldoRacao == undefined)
                    {
                        this.$axios.post('informe-saldo-racao/', rec)
                        .then(() => {
                            this.$emit('saved')
                            this.$emit('closeDialog')
                        })
                        .catch((error) => {
                            this.$store.commit('setSnack', {type: 'error', msg : error})
                        })
                    }
                    else
                    {
                        this.$axios.put('informe-saldo-racao/' + this.rec.idInformeSaldoRacao, rec)
                        .then(() => {
                            this.$emit('saved')
                            this.$emit('closeDialog')
                        })
                        .catch((error) => {
                            this.$store.commit('setSnack', {type: 'error', msg : error})
                        })
                    }
                }
            },
            beforeDeleteRationBalance() {
                this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 300 })
                .then(confirm => {
                    if (confirm)
                        this.deleteRationBalance()
                })
            },
            deleteRationBalance() {
                this.$axios.delete('informe-saldo-racao/' + this.rec.idInformeSaldoRacao)
                .then(() => {
                    this.$emit('saved')
                    this.$emit('closeDialog')
                })
            },
            cancel() {
                this.$emit('closeDialog')
            }
        },
        props: {
            dialog: {
                type: Boolean,
                default: false
            },
            rec: {
                type: Object,
                default: () => ({})
            }
        },
        watch: {
            'dialog' (newValue, oldValue) {
                if (newValue && !oldValue)
                {
                    this.initComponent()
                }
            }
        }
    }
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
